import { isValidPhoneNumber } from 'libphonenumber-js';

const GB_DEFAULT_COUNTRY = 'GB';

/**
 * Validates UK contact numbers for broker flows. National input is parsed as GB; valid international (+…) forms are accepted.
 */
export function isValidGbPhoneNumber(value: string | null | undefined): boolean {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) {
    return false;
  }
  return isValidPhoneNumber(trimmed, GB_DEFAULT_COUNTRY);
}

interface GbPhoneAntdRuleOptions {
  warningOnly?: boolean;
}

/** Ant Design / Pro Form rule — skips empty values so `required` can handle them. */
export function gbPhoneNumberAntdRule(message: string, options?: GbPhoneAntdRuleOptions) {
  return {
    warningOnly: options?.warningOnly,
    validator: async (_: unknown, value: unknown) => {
      const trimmed = String(value ?? '').trim();
      if (!trimmed) {
        return Promise.resolve();
      }
      if (!isValidGbPhoneNumber(trimmed)) {
        return Promise.reject(new Error(message));
      }
      return Promise.resolve();
    },
  };
}
